module.exports = __webpack_public_path__ + "img/agpz-car-default.14eaad34.svg";